
export enum SortDirections {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum SortField {
  CutDate = 'cutDate',
  SyncDate = 'syncDate',
  CutType = 'cutType',
  Status = 'cutStatus',
  Product = 'productName',
  Company = 'company',
  Location = 'location',
  Manufacturer = 'manufacturer',
  Model = 'model',
  Coverage = 'coverage',
  Country = 'country',
  EmployeeEmail = 'employeeEmail',
  Category = 'category',
}
